<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
  <form @submit.prevent="checkIfFromGame">
    <c-card>
      <h3
          slot="title"
          color="green"
      >
        פרטי שאלה
      </h3>
      <question-type-select
          v-model="form.question_type"
          label="סוג שאלה"
      />
      <smart-input
          v-model="form.question"
          textarea
          :error="inputErrors.question"
          :required="config.questionRequired"
          label="תוכן השאלה"
      />
      <add-media
          v-if="!hasImage"
          :before_question_media="form.before_question_media"
          :before_question="form.before_question"
          :before_question_text="form.before_question_text"
          :input-errors="inputErrors"
          :is-new="!form.id"
          @before_question_media="form.before_question_media = $event"
          @before_question="form.before_question = $event"
          @before_question_text="form.before_question_text = $event"
          @updatedQuestionImage="updateQuestionImage"
      />
      <div
          v-if="hasImage"
          class="my-3"
      >
        <v-icon
            class="close"
            @click="cancelImg"
        >
          close
        </v-icon>
        <v-img
            :src="form.before_question"
            max-height="150"
            max-width="250"
        />
      </div>
      <tags-select
          :initial-tags="form.tags"
          @input="form.tags = $event"
      />

      <!--		don`t remove-->
      <!--		<smart-input type="checkbox" :error="inputErrors.true_false_answer" label='האם התשובה נכונה' v-model="form.true_false_answer"></smart-input>-->
      <!--		<smart-input :error="inputErrors.before_question" label='לפני שאלה' v-model="form.before_question"></smart-input>-->
      <!--		<media-type-select label='סוג מדיה לפני שאלה' v-model="form.before_question_media"></media-type-select>-->
      <!--		<smart-input :error="inputErrors.after_answer" label='אחר שאלה' v-model="form.after_answer"></smart-input>-->
      <!--		<media-type-select label='סוג מדיה אחרי שאלה' v-model="form.after_answer_media"></media-type-select>-->
      <!--		<smart-input :error="inputErrors.timer" type="number" label='זמן מענה בשניות' v-model="form.timer"></smart-input>-->
      <!--		don`t remove-->
    </c-card>
    <c-card v-if="!isMusagQuestion">
      <h3
          slot="title"
          color="green"
      >
        תשובות
      </h3>
      <v-btn
          v-if="config.multiAnswer"
          slot="bar-actions"
          icon
          @click="addAnswer()"
      >
        <v-icon circle>
          add
        </v-icon>
      </v-btn>
      <answer-form
          :can-remove="false"
          label="התשובה הנכונה"
          :answer="answer"
          :media="config.mediaInAnswer"
          @updatedAnswerImage="updateAnswerImage"
      />
      <v-divider/>
      <div v-if="config.multiAnswer">
        <answer-form
            v-for="a in answers"
            :key="a.id"
            label="תשובה לא נכונה"
            :answer="a"
            @remove="removeAnswer(a)"
            @updatedAnswerImage="updateAnswerImage"
        />
      </div>
    </c-card>
    <div class="mt-3">
      <v-row>
        <v-col>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                הגדרות מתקדמות
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <smart-input
                    v-model="form.hint"
                    label="רמז לתשובה"
                    :error="inputErrors.hint"
                />
                <smart-input
                    v-model="form.text_after_answer"
                    textarea
                    label="הרחבה לאחר התשובה"
                    :error="inputErrors.hint"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </div>
    <cols-row
        cols="6"
        :row="{ justify: 'center' }"
    >
      <btn-loader :progress="false">
        שמירה
      </btn-loader>
      <v-btn
          x-large
          type="button"
          class="my-2"
          @click="onCancel"
      >
        ביטול
      </v-btn>
    </cols-row>
  </form>
</template>

<script>
import QuestionModule from "../../store/Question.module";
import FormView from "dev/mixins/FormView";
import TagsSelect from "../questions/TagsSelect";
import QuestionTypeSelect from "../questions/QuestionTypeSelect";
import AddMedia from "../questions/AddMedia";
import {
  getConfig,
  types as QuestionType,
} from "root/packages/closeapp/QuestionsManager/assets/types/QuestionType";
import AnswerForm from "../answers/AnswerForm";
import {uniqueId} from "lodash";
import CCard from "dev/scaffoldings/cCard";
import BtnLoader from "dev/components/BtnLoader";

export default {
  name: "QuestionForm",
  components: {
    BtnLoader,
    CCard,
    AnswerForm,
    QuestionTypeSelect,
    TagsSelect,
    AddMedia,
  },
  props: {
    fromGameMenu: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: null,
        before_question_media: "",
        before_question_text: "",
      },
      answer: {},
      answers: [],
    };
  },
  mixins: [new FormView(QuestionModule, "question", true)],
  computed: {
    isNew() {
      return !!this.question.id;
    },
    hasAnswerContent() {
      return this.answers.filter((a) => !!a.content).length;
    },
    closeQuestion() {
      return +this.form.question_type === QuestionType.CLOSE;
    },
    config() {
      return getConfig(this.form.question_type);
    },
    hasImage() {
      return (this.form.before_question_media === "img" && this.form.before_question !== "" && this.form.before_question !== null);
    },
    isMusagQuestion() {
      return this.form.question_type === 5;
    },
  },
  watch: {
    "form.question_type": {
      handler() {
        if (this.hasAnswerContent) {
          return;
        }
        if ([1, 4, 5].includes(this.form.question_type)) {
          if (this.answers.length < 3) {
            this.addAnswer({is_right: false});
            this.addAnswer({is_right: false});
          }
        } else {
          this.answers = [];
          this.addAnswer();
        }
      },
      immediate: true,
    },
    "form.answers": {
      handler() {
        if (this.form.answers && this.form.answers.length) {
          this.answers = this.form.answers.slice(0);
        } else {
          this.addAnswer({is_right: false});
        }
      },
      immediate: true,
    },
    "form.answer": {
      immediate: true,
      handler() {
        this.answer = Object.assign({}, this.form.answer);
      },
    },
  },
  methods: {
    checkIfFromGame(e) {
      if (this.fromGameMenu) {
        swal.fire({
          type: "info",
          title: "האם לערוך שאלה זו עבור כל המשחקים, או רק עבור משחק זה?",
          confirmButtonText: "עבור כל המשחקים",
          showCloseButton: true,
          showDenyButton: true,
          denyButtonText: "עבור משחק זה בלבד",
        }).then((choice) => {
          if (choice.isDenied) {
            this.form.thisGameOnly = true;
            this.onSubmit(e);
          } else if (choice.isConfirmed) {
            this.form.thisGameOnly = false;
            this.onSubmit(e);
          }
        });
      } else {
        this.form.thisGameOnly = false;
        this.onSubmit(e);
      }
    },
    beforeSubmit(formData) {
      this.form.answer = this.answer;
      if (this.form.before_question_media === "img" && this.form.before_question === null) {
        this.form.before_question_media = "text";
      }
      const data = Object.assign({}, this.form, {answers: this.answers});
      data.newTags = data.tags.filter((tag) => tag && typeof tag === "string");
      data.tags = data.tags.filter((tag) => tag.id).map((tag) => tag.id);
      formData.append("question", JSON.stringify(data));
      return formData;
    },

    removeAnswer(answer) {
      const index = this.answers.indexOf(answer);
      if (index > -1) {
        this.answers.splice(index, 1);
      }
    },
    addAnswer(settings = []) {
      this.answers.push({
        id: uniqueId("notreal"),
      });
    },
    onCancel() {
      this.$emit("cancel", this.gamelog);
    },
    updateAnswerImage(img) {
      this.answer.media_src = img.imageSrc;
    },
    updateQuestionImage(img) {
      this.form.before_question = img.imageSrc;
    },
    cancelImg() {
      this.form.before_question = null;
    },
  },
};
</script>

<style scoped lang="scss">
.close {
  cursor: pointer;
}
</style>
